import { AdvancedMarker } from '@vis.gl/react-google-maps'
import { useCallback } from 'react'

import { Drawer } from '#/components/Drawer'
import { Icon } from '#/components/Icon'
import { DrawerFetch } from '#/components/Maps/components/DrawerFetch'
import Pin from '#/components/Maps/components/Pin'
import CComDrawer, { CComFooter } from '#/components/Maps/Markers/CCom/drawer'
import { CCom } from '#/components/Maps/Markers/types'
import { endpoint } from '#/store/services/endpoints'
import { store } from '#/store/store'
import Colors from '#/styles/Colors'

interface CComMarkerProps {
  marker: CCom
  setMarkerRef: (marker: google.maps.marker.AdvancedMarkerElement, slug: string) => void
}

export function ccomDrawerOpen(marker: CComMarkerProps['marker']) {
  const farmSlug = store.getState().farm?.farm?.slug

  const controller = farmSlug
    ? endpoint.farm.c_com.self({ ccom: marker.slug, farm: farmSlug })
    : endpoint.ccom.self({ ccom: marker.slug })

  Drawer.open({
    content: (
      <DrawerFetch
        controller={controller}
        render={data => <CComDrawer data={data} ccom={marker} />}
      />
    ),
    footer: <CComFooter marker={marker} />,
  })
}

const icons = {
  primary: {
    inactive: 'c-com-primary', // sim, é isso
    offline: 'primary-c-com-offline',
    operational: 'c-com-primary',
    waiting: 'primary-c-com-waiting',
  },
  secondary: {
    inactive: 'connected', // sim, é isso
    offline: 'disconnected',
    operational: 'connected',
    waiting: 'partially-disconnected',
  },
}

export function CComMarker({ marker, setMarkerRef }: CComMarkerProps) {
  const ref = useCallback(
    (ref: google.maps.marker.AdvancedMarkerElement) => {
      if (ref) {
        Object.assign(ref, { status_for_map: marker?.status_for_map })
      }
      setMarkerRef(ref, marker.id)
    },
    [setMarkerRef, marker.id],
  )

  const status = marker.status_for_map ?? 'inactive'

  const ccom = marker.primary ? 'primary' : 'secondary'

  const iconType = icons[ccom]?.[status]

  return (
    <AdvancedMarker
      key={marker.slug}
      position={marker}
      onClick={() => ccomDrawerOpen(marker)}
      ref={ref}
    >
      <Pin
        icon={<Icon size="large" name={iconType} />}
        backgroundColor={Colors.map.markers.ccom[status]}
      />
    </AdvancedMarker>
  )
}
